import appConfig from '../../../config/appConfig';

var shipmentsConfig = {
  apiUrl: appConfig.apiUrl + 'shipments/'
};

export default shipmentsConfig;



// WEBPACK FOOTER //
// ./src/components/shipments/config/shipmentsConfig.js